import { render, staticRenderFns } from "./Header5.vue?vue&type=template&id=06c89f8c"
import script from "./Header5.vue?vue&type=script&lang=js"
export * from "./Header5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports